"use client"

import { useLayoutEffect, useSyncExternalStore, type ReactNode } from "react"
import { createPortal } from "react-dom"
import { useOverviewTheme } from "@/features/crm/dashboard/overview-theme"
import { ToastStack, ToastStackProvider } from "./toast-stack/toast-stack"
import { getArcPortalRoot } from "./portal"
import "./foundation.css"
import "./integration.css"

const portalSnapshot = () => document.querySelector<HTMLElement>("[data-danaro-arc-portal]");
function subscribePortal() { getArcPortalRoot(); return () => {}; }

export function UiScope({ children, className = "" }: { children: ReactNode; className?: string }) {
  const theme = useOverviewTheme()
  return <div className={`danaro-arc-scope ${className}`} data-ui-scope data-theme={theme} data-accent="neutral">{children}</div>
}
export function ArcUiProvider({ children }: { children: ReactNode }) {
  const theme = useOverviewTheme()
  const portal = useSyncExternalStore(subscribePortal, portalSnapshot, () => null)
  useLayoutEffect(() => { const root = getArcPortalRoot(); if (root) root.dataset.theme = theme }, [theme])
  useLayoutEffect(() => () => { document.querySelector("[data-danaro-arc-portal]")?.remove() }, [])
  return <ToastStackProvider duration={5000} limit={12}>{children}{portal && createPortal(<UiScope><ToastStack className="danaro-toast-stack" label="Danaro notifications" position="bottom-right" visibleToasts={3} /></UiScope>, portal)}</ToastStackProvider>
}
